import React, { Fragment, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import { Button, useMutation, useNotify, useRefresh } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";
import { StyledButton } from "../../../components/ListShowButton";

interface IApproveButton {
  id: number;
}

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  cancelButton: {
    backgroundColor: "#eeeeee",
    color: "black",
  },
});

const ConfirmButton = ({ id }: IApproveButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleApprove, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `subcontractorAdjustmentPrices/${id}/approve`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully approve adjustment price.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed approve adjustment price, error: ${error.message}`,
          "warning",
        ),
    },
  );

  return (
    <Button
      onClick={handleApprove}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      disabled={loading}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const ApproveButton = ({ id }: IApproveButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <StyledButton variant="outlined" onClick={handleOpenDialog}>
        Approve
      </StyledButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Approve The Adjustment Price
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure you want to approve the adjustment price?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            label="Back"
            color="secondary"
            onClick={handleClose}
            className={classes.cancelButton}
          />
          <ConfirmButton id={id} />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ApproveButton;
